import { BaseService } from "./BaseService";
import {
  CreateSubscriptionPlanPayload,
  ListSubscriptionPlansQuery,
  SubscriptionPlan,
  UpdateSubscriptionPlanPayload,
} from "@/types/subscription-plan";

function listQueryToParams(
  query: ListSubscriptionPlansQuery,
): Record<string, string> {
  const params: Record<string, string> = {};
  if (query.status !== undefined) {
    params.status = query.status;
  }
  if (query.isDefault === true || query.isDefault === false) {
    params.isDefault = query.isDefault ? "true" : "false";
  }
  return params;
}

class CatalogSubscriptionPlansService extends BaseService {
  private readonly basePath = "/admin/subscriptions/plans";

  constructor() {
    super();
  }

  async getPlans(
    query?: ListSubscriptionPlansQuery,
  ): Promise<SubscriptionPlan[]> {
    const params = query === undefined ? undefined : listQueryToParams(query);
    const hasParams = params !== undefined && Object.keys(params).length > 0;
    const raw = await this.get<SubscriptionPlan[]>(
      this.basePath,
      hasParams ? params : undefined,
    );
    return Array.isArray(raw) ? raw : [];
  }

  createPlan(
    payload: CreateSubscriptionPlanPayload,
  ): Promise<SubscriptionPlan> {
    return this.post<SubscriptionPlan>(this.basePath, payload);
  }

  async createCustomPlan(
    tenantId: string,
    payload: CreateSubscriptionPlanPayload,
  ): Promise<SubscriptionPlan> {
    const qs = new URLSearchParams({ tenantId }).toString();
    return this.post<SubscriptionPlan>(
      `${this.basePath}/custom?${qs}`,
      payload,
    );
  }

  async updatePlan(
    id: string,
    payload: UpdateSubscriptionPlanPayload,
  ): Promise<SubscriptionPlan> {
    return this.patch<SubscriptionPlan>(`${this.basePath}/${id}`, payload);
  }

  deletePlan(id: string): Promise<void> {
    return this.delete<void>(`${this.basePath}/${id}`);
  }
}

export const catalogSubscriptionPlansService =
  new CatalogSubscriptionPlansService();
